var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{staticClass:"pagination-container",class:{'hidden':_vm.hidden},attrs:{"page-size":_vm.limit,"current-page":_vm.page,"page-sizes":_vm.pageSizes,"background":"","layout":_vm.layout,"total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }